// extracted by mini-css-extract-plugin
export default {"icon":"icon_icon__WQNrA","primary":"icon_primary__bt4bz","alert":"icon_alert__bXEgy","default":"icon_default__VuH7R"};